import { HTMLProps } from 'react';

import Sketch from './Sketch';
import { CatalogueEntryDisplay } from '../../hooks/useCatalogue';

export interface SketchProps extends HTMLProps<SVGSVGElement> {
	dimensions: CatalogueEntryDisplay;
}

export default Sketch;